import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Input } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { handleApiError } from '../../../../../utils/handleApiError.js';
import OTPModal from "../../../../../components/modals/OTPModal.jsx";
import { AddWithdrawRequestApi, VerifyWithdrawTransactionApi, ResendWithdrawTransactionApi } from '../../../../../api/request/wallet/withdraw.js';

const CashWithdraw = ({ amount, resetAll }) => {
  const [form] = Form.useForm();
  const { userDetails } = useSelector(state => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [otp, setOtp] = useState("");

  const [otpLoading, setOtpLoading] = useState(false);
  const [pendingRequestId, setPendingRequestId] = useState(null);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const params = {
        userId: userDetails?._id,
        amount: Number(amount),
        withdrawalMethod: 6,
        ...values
      };

      const { data } = await AddWithdrawRequestApi(params);
      if (data?.success) {
        toast.success(data?.message);
        setIsOTPModalOpen(true);
        setOtp("");
        setPendingRequestId(data?.data?.requestId);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleOtpSubmit = async (otpVal) => {
    try {
      setOtpLoading(true);
      const payload = { requestId: pendingRequestId, otp: otpVal, actionType: 1 };
      const { data } = await VerifyWithdrawTransactionApi(payload);
      if (data?.success) {
        toast.success(data?.message || 'Withdrawal verified successfully');
        setIsOTPModalOpen(false);
        setOtp("");
        form?.resetFields();
        resetAll();
      } else {
        toast.error(data?.message || 'Failed to verify OTP');
        setIsOTPModalOpen(true);
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setOtpLoading(false);
    }
  };

  const handleOtpResend = async () => {
    try {
      setOtp("");
      if (!pendingRequestId) {
        toast.error('Please request for withdraw first');
        return false;
      }
      const payload = { requestId: pendingRequestId, actionType: 1 };
      const { data } = await ResendWithdrawTransactionApi(payload);
      if (data?.success) {
        toast.success(data?.message || 'OTP resent');
        return true;
      } else {
        toast.error(data?.message || 'Failed to resend OTP');
        return false;
      }
    } catch (err) {
      handleApiError(err);
      return false;
    }
  };


  return (
    <div>
      <Form form={form} layout="vertical" className='space-y-5' onFinish={handleSubmit}>
        <div className="grid sm:grid-cols-2 gap-5">
          <Form.Item
            name="mobileNumber"
            label={<span className="text-lg text-gray-500 font-medium">Mobile Number</span>}
            rules={[{ required: true, message: 'Please enter mobile number' }]}
          >
            <Input placeholder="Mobile Number" size='large' type='number' className='py-3 md:py-1.5' />
          </Form.Item>
        </div>

        <Form.Item
          name='conditions'
          valuePropName="checked"
          rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
        >
          <Checkbox className='mt-4'>
            Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
          </Checkbox>
        </Form.Item>

        <LoadableButton
          className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-3 md:py-2 w-full md:w-auto uppercase themeHover duration-500'
          type="submit"
          lable='Submit'
          isLoading={isLoading}
          loadingLable='Adding request...'
        />
      </Form>
      <OTPModal
        isOpen={isOTPModalOpen}
        setIsOpen={setIsOTPModalOpen}
        title='OTP Verification'
        message='Please enter the OTP to verify withdrawal request.'
        width={600}
        value={otp}
        onChange={(val) => setOtp(val)}
        onSubmit={handleOtpSubmit}
        onResend={handleOtpResend}
        isLoading={otpLoading}
        loadingLabel='Verifying...'
        submitLabel='Verify'
        otpDuration={120}
      />
    </div>
  )
}

export default CashWithdraw


